<template>
  <div class="container">
    <ConfirmDialog
      :isOpen="dialogState.isOpen"
      :title="dialogState.type === 'accepted' ? 'ยืนยันการตอบรับ' : 'ยืนยันการสละสิทธิ์'"
      :message="dialogState.type === 'accepted'
        ? 'คุณต้องการยืนยันรับของรางวัล ' + dialogState.memberName + ' ใช่หรือไม่?'
        : 'คุณต้องการให้ ' + dialogState.memberName + ' สละสิทธิ์ใช่หรือไม่?'"
      :confirmText="dialogState.type === 'accepted' ? 'ตกลง' : 'สละสิทธิ์'"
      cancelText="ยกเลิก"
      :type="dialogState.type || 'accepted'"
      :loading="isConfirming"
      @confirm="confirmDialogAction"
      @cancel="closeDialog"
    />

    <div class="card shadow-lg">
      <div class="card-body" style="min-height: 600px !important;">
        <div class="text-center mb-4">
          <h1 class="card-title text-primary mb-2">Lucky Draw</h1>
          <p class="text-muted">CGS CI&OE 2025</p>
        </div>
        <!-- {{ selectedMembers2[0].liffUserId }} -->
        <div class="mb-4">
          <v-btn
            color="#4666e7"
            :loading="isAnimating"
            @click="randomizeMembers"
            :disabled="isAnimating || countAccepted >= 3 || selectedMembers2[0].liffUserId"
            class="btn btn-primary btn-lg btn-block shuffle-btn text-white"
          >
            <v-icon left small>mdi-shuffle</v-icon>
            {{ isAnimating ? 'กำลังสุ่ม...' : countAccepted >= 3 ? 'สุ่มครบแล้ว' : 'สุ่มสมาชิก'  }}
          </v-btn>
        </div>
        <div>

        </div>
        <div v-if="selectedMembers.length > 0 && countAccepted < 3" class="mt-4">
          <div class="border-top pt-4">
            <h2 class="h5 text-center mb-4">สมาชิกที่ถูกเลือก</h2>

            <div>
              <div
                v-for="(member, index) in selectedMembers2"
                :key="member.liffUserId || index"
                class="member-card p-3 mb-3 rounded"
                style="border-radius: 20px !important;"
                :class="{
                  'member-accepted': member.status === 'accepted',
                  'member-pending':  member.status === 'accept',
                  'member-empty': member.liffUserId === null
                }"
              >
                <div class="d-flex align-items-center mb-3">
                  <div class="member-avatar">
                    <img
                      v-if="member.picture"
                      :src="member.picture"
                      class="avatar-image"
                      alt="avatar"
                    />
                    <v-icon
                      v-else
                      :color="member.liffUserId === null ? 'grey' : 'primary'"
                      size="48"
                    >
                      mdi-account-circle
                    </v-icon>
                  </div>

                  <div class="flex-grow-1 ml-3">
                    <div class="font-weight-bold">{{ 'คุณ ' + member.name }}</div>
                    <div class="text-muted small">
                      สมาชิกคนที่ถูกเลือก
                      {{ member.status }}
                      <span v-if="member.status === 'accepted'" class="ml-2 text-success">✓ ตอบรับ</span>
                      <span v-if="member.status === 'declined'" class="ml-2 text-danger">✗ สละสิทธิ์</span>
                    </div>
                    <div v-if="member.tel" class="text-muted small">
                      เบอร์โทรศัพท์ {{ member.tel }}
                    </div>
                  </div>
                </div>

                <div v-if=" member.status === 'accept' && member.liffUserId !== null" class="d-flex">
                  <button
                    @click="openAcceptDialog(member.liffUserId, member.name)"
                    class="btn btn-success btn-sm flex-fill mr-2"
                  >
                    <v-icon left x-small>mdi-check</v-icon>
                    ตกลง
                  </button>

                  <button
                    @click="openDeclineDialog(member.liffUserId, member.name)"
                    class="btn btn-danger btn-sm flex-fill"
                  >
                    <v-icon left x-small>mdi-close</v-icon>
                    สละสิทธิ์
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ConfirmDialog from './ConfirmDialog.vue'
import axios from 'axios'

export default {
  components: { ConfirmDialog },

  data () {
    return {
      isAnimating: false,
      isConfirming: false,
      countAccepted: 0,
      selectedMembers: [
        { liffUserId: null, name: '-', picture: null, status: null },
        { liffUserId: null, name: '-', picture: null, status: null },
        { liffUserId: null, name: '-', picture: null, status: null }
      ],
      selectedMembers2: [
        { liffUserId: null, name: '-', picture: null, status: null }
      ],
      allMembers: [],
      dialogState: {
        isOpen: false,
        type: 'accepted',
        memberId: null,
        memberName: ''
      }
    }
  },

  async mounted () {
    // โหลดข้อมูลสมาชิกจาก API เมื่อ component ถูก mount
    await this.fetchMembersAcceptedOrAccept()
  },

  methods: {
    async fetchMembersAcceptedOrAccept () {
      try {
        this.countAccepted = 0
        const response = await axios.get(
          this.DNS_IP + '/CGS-activity/AcceptedAndAccapt'
        )

        // ถ้ามีข้อมูลจาก API ให้แสดงผล ถ้าไม่มีให้แสดง placeholder 3 ช่อง
        if (response.data && response.data.length > 0) {
          // กรองเอาเฉพาะสมาชิกที่ไม่ใช่ declined และแปลงข้อมูล
          this.selectedMembers = response.data
            .filter(member => member.voucher !== 'declined')
            .map(member => ({
              id: member.liffUserIdCGS_Member || member.liffUserId,
              name: member.name,
              picture: member.picture || null,
              status: member.voucher || null,
              memberId: member.memberId,
              liffUserId: member.liffUserId,
              tel: member.tel
            }))

          // while (members.length < 3) {
          //   members.push({ id: null, name: '-', picture: null, status: null, memberId: null, liffUserId: null })
          // }
          this.countAccepted = this.selectedMembers.length
        } else {
          // ถ้าไม่มีข้อมูลให้แสดง placeholder
          this.selectedMembers = [
            { id: null, name: '-', picture: null, status: null, memberId: null, liffUserId: null },
            { id: null, name: '-', picture: null, status: null, memberId: null, liffUserId: null },
            { id: null, name: '-', picture: null, status: null, memberId: null, liffUserId: null }
          ]
        }

        console.log('response', response)
      } catch (error) {
        console.error('Error fetching members:', error)
        // ถ้า error ให้แสดง message หรือใช้ mock data
        alert('ไม่สามารถโหลดข้อมูลสมาชิกได้')
      }
    },
    async fetchMembers () {
      try {
        const response = await axios.post(
          this.DNS_IP + '/CGS-activity/member_success'
        )

        // แปลงข้อมูลจาก API เป็นรูปแบบที่ใช้ใน component
        this.allMembers = response.data.map(member => ({
          id: member.liffUserIdCGS_Member,
          name: member.name,
          avatar: this.getAvatarFromPicture(member.picture),
          memberId: member.memberId,
          liffUserId: member.liffUserId,
          tel: member.tel,
          picture: member.picture
        }))

        console.log('Members loaded:', this.allMembers)
      } catch (error) {
        console.error('Error fetching members:', error)
        // ถ้า error ให้แสดง message หรือใช้ mock data
        alert('ไม่สามารถโหลดข้อมูลสมาชิกได้')
      }
    },
    async randomizeMembers () {
      this.isAnimating = true

      // this.count = this.selectedMembers.filter(m => m.liffUserId !== null).length
      let dt = {
        'count': 1
      }
      let result = await axios.post(
        this.DNS_IP + '/CGS-activity/member_success', dt
      )
      this.isAnimating = false
      if (!result.data) {
        alert('ไม่มีสมาชิก')
      } else {
        this.selectedMembers2 = result.data
          .map(member => ({
            id: member.liffUserIdCGS_Member || member.liffUserId,
            name: member.name,
            picture: member.picture || null,
            status: 'accept',
            memberId: member.memberId,
            liffUserId: member.liffUserId,
            tel: member.tel
          }))
        console.log('this.selectedMembers2', this.selectedMembers2)
      }
      // await this.fetchMembersAcceptedOrAccept()
    },

    openAcceptDialog (liffUserId, name) {
      this.dialogState = {
        isOpen: true,
        type: 'accepted',
        liffUserId: liffUserId,
        memberName: name
      }
    },

    openDeclineDialog (liffUserId, name) {
      this.dialogState = {
        isOpen: true,
        type: 'declined',
        liffUserId: liffUserId,
        memberName: name
      }
    },

    closeDialog () {
      this.dialogState.isOpen = false
    },

    async confirmDialogAction () {
      this.isConfirming = true
      try {
        const m = this.selectedMembers2.find(m => m.liffUserId === this.dialogState.liffUserId)
        if (m) m.status = this.dialogState.type
        let dt = {
          'voucher': this.dialogState.type
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/CGS-activity-AcceptOrDeclined/edit/" + this.dialogState.liffUserId,
            dt
          )
        // this.selectedMembers2 = []
        await this.fetchMembersAcceptedOrAccept()
        this.selectedMembers2 = [
          { id: null, name: '-', picture: null, status: null, memberId: null, liffUserId: null }
        ]
        this.closeDialog()
      } catch (error) {
        console.log('error', error)
      } finally {
        this.isConfirming = false
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 1rem;
}

.card {
  border-radius: 1rem;
  border: none;
}

.shuffle-btn {
  border-radius: 0.75rem;
  font-weight: 500;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
}

.shuffle-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.shuffle-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.member-card {
  border: 2px solid #dee2e6;
  transition: all 0.15s ease-in-out;
}

.member-accepted {
  background-color: #d4edda;
  border-color: #28a745;
}

.member-declined {
  background-color: #f8d7da;
  border-color: #dc3545;
  opacity: 0.7;
}

.member-pending {
  background-color: #e7f1ff;
}

.member-empty {
  height: 150px !important;
  background-color: #f8f9fa;
  border-color: #dee2e6;
  opacity: 0.5;
}

.member-avatar {
  transition: all 0.15s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.btn-sm {
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-sm:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/RandomCGS.vue